import { action, computed, makeObservable } from 'mobx';
import {StringControl} from '../../../../../lib/helpers';
import {InlineOpenEndedQuestionModel, OpenEndedQuestionParagraph} from '../models';
import {crudHelper} from './crudHelper';

export class OpenEndedQuestionEditStore {
  readonly serialized: StringControl;

  constructor() {
    makeObservable(this);
    this.serialized = new StringControl('', '');
  }

  @action
  setModel = (model: InlineOpenEndedQuestionModel) => {
    this.serialized.setValue(crudHelper.serializeParagraphs(model.paragraphs));
  };

  @computed
  get paragraphs(): OpenEndedQuestionParagraph[] {
    return crudHelper.deserializeParagraphs(this.serialized.value);
  }

  @computed
  get countInputs(): number {
    return crudHelper.countInputs(this.serialized.value);
  }

  @computed
  get valid(): boolean {
    return true;
  }

  @computed
  get model(): InlineOpenEndedQuestionModel {
    return {
      paragraphs: this.paragraphs
    };
  }

  @computed
  get x9Content(): string {
    return JSON.stringify(this.model);
  }
}
